import * as React from 'react';

import * as _ from 'lodash';

import { makeStyles } from '@material-ui/core/styles';

import {
    Grid,
    Paper, Card,
    Typography,
    AppBar, Tabs, Tab,
    FormControl, InputLabel, Select, MenuItem, TextField, FormHelperText
} from '@material-ui/core';
// import {
//     DataGrid, ColDef
// } from '@material-ui/data-grid'

import { AgGridReact, AgGridColumn, AgGridReactProps } from '@ag-grid-community/react';
import {
    GridApi, ColumnApi,
    ValueGetterParams,
    ColDef,
    ICellEditorParams, ICellRendererParams
    // ClientSideRowModelModule,
    // RichSelectModule
} from '@ag-grid-enterprise/all-modules';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RichSelectModule } from '@ag-grid-enterprise/rich-select';

import { useDebounce } from '../lib/debounce';

import * as ConfigurationCore from '../lib/services/configuration.core';
import * as ConfigurationLayout from '../lib/services/configuration.layout';
import * as ConfigurationProjectionLayoutGrid from '../lib/services/configuration.projectionLayoutGrid';

export interface GridColumn {
    label: string;
    source: string;
}

// const columns: ColDef[] = [
//     { field: 'id', headerName: 'ID', width: 200 },
//     { field: 'Name', headerName: 'Name', width: 200 },
//     { field: 'Tag', headerName: 'Tag', width: 200 },
//     { field: 'SizeIdentifier', headerName: 'Identifier', width: 200 },
//     { field: 'Height', headerName: 'Height', width: 70 },
//     { field: 'FreeArea', headerName: 'FreeArea', width: 100 },
//     { field: 'Model', headerName: 'Model', width: 100 }
// ]

const styles = makeStyles((theme) => ({
    groupHeader: {
        paddingBottom: theme.spacing(1)
    },
    paperContainer: {
        padding: theme.spacing(1)
    }
}));

interface AgGridData {
    modules: any[];
    rowData: AgGridRowData[];
    columnDefs: ColDef[];
    defaultColDef: Record<string, any>;
    frameworkComponents: any;
}
interface AgGridRowData {
    layoutGridRow: ConfigurationProjectionLayoutGrid.Row;
    [key: string]: unknown;
}

export interface LayoutGridProps {
    grid: ConfigurationProjectionLayoutGrid.Grid;
    // entities: ConfigurationLayout.Entity[];
    // columns: GridColumn[];
    debugging?: boolean;
    onChange?: (e: { id: string, state: Record<string, string> }) => void;
    onSelectionChanged?: (ids: string[]) => void;
}
export function LayoutGrid({ grid, debugging, onChange, onSelectionChanged }: LayoutGridProps) {
    const classes = styles();

    const [ gridApi, setGridApi ] = React.useState<GridApi>();
    const [ gridColumnApi, setGridColumnApi ] = React.useState<ColumnApi>();
    const onGridReady: AgGridReactProps['onGridReady'] = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);

        params.api.sizeColumnsToFit();
    }
    const onGridCellChange: AgGridReactProps['onCellValueChanged'] = (params) => {
        console.log('onGridCellChange', params)

        // const entity = entities.find(e => e.entityId === params.data.id);
        // if (!entity)
        //     return;

        const column = grid.columns.find(c => c.name === params.column.getColId());
        if (!column)
            throw new Error(`Invalid column ${params.column.getColId()}`);

        onChange?.({
            id: params.data.id,
            state: {
                [column.source]: params.value?.toString()
            }
        });
    }
    const onRowSelected: AgGridReactProps['onRowSelected'] = (params) => {
        // console.log(params.api.getSelectedNodes())
    }
    const onGridSelectionChanged: AgGridReactProps['onSelectionChanged'] = (params) => {
        const selectedNodes = _.compact(params.api.getSelectedNodes().map(node => node.data.id));
        onSelectionChanged?.(selectedNodes);
    }

    const [ gridData, setGridData ] = React.useState<AgGridData>();
    React.useEffect(() => {
        const gridData: AgGridData = {
            modules: [
                ClientSideRowModelModule,
                RichSelectModule
            ],
            rowData: grid.rows.map(row => {
                const rowData: AgGridRowData = {
                    layoutGridRow: row,
                    id: row.entityId,
                    status: 'Valid'
                };

                for (const field of row.fields) {
                    rowData[field.columnName] = field.getPropertyValue('value')?.toString();
                }

                return rowData;
            }),
            columnDefs: [
                {
                    field: 'status',
                    headerName: 'Status',
                    editable: false,
                    cellRenderer: 'layoutGridCellRenderer'
                },
                {
                    field: 'selected',
                    headerName: 'Selected',
                    checkboxSelection: true,
                    editable: false
                },
                ...grid.columns.filter(c => c.visible || debugging).map(column => resolveColDef(column))
            ],
            defaultColDef: {
                flex: 1,
                minWidth: 130,
                editable: true,
                resizable: true
            },
            frameworkComponents: {
                layoutGridCellRenderer: LayoutGridCellRenderer,
                layoutGridCellEditor: LayoutGridCellEditor
            }
        }

        // console.log('SET GRID DATA', gridData)
        setGridData(gridData);
        gridApi?.setRowData(gridData.rowData);
    }, [ grid, debugging ]);

    // const valueGetter: (colDef: ColDef) => ((params: ValueGetterParams) => string) = (colDef: ColDef) => (params => {
    //     return colDef.field
    // });

    return (
        <React.Fragment>
            <div className="ag-theme-alpine" style={{ height: 400 }}>
                {gridData && <AgGridReact
                    modules={gridData.modules}
                    rowData={gridData.rowData}
                    columnDefs={gridData.columnDefs}
                    defaultColDef={gridData.defaultColDef}
                    frameworkComponents={gridData.frameworkComponents}
                    onGridReady={onGridReady}
                    onCellValueChanged={onGridCellChange}
                    onRowSelected={onRowSelected}
                    onSelectionChanged={onGridSelectionChanged}
                    rowSelection="multiple"
                    singleClickEdit
                />}
                {/* <AgGridReact rowSelection="multiple" rowData={gridData} onGridReady={onGridReady} onCellValueChanged={onGridCellChange} onRowSelected={onRowSelected} onSelectionChanged={onGridSelectionChanged}>
                    {grid.columns.filter(c => c.visible).map((column, idx) => <AgGridColumn field={column.name} headerName={column.displayName} sortable filter editable checkboxSelection={idx === 0}></AgGridColumn>)}
                </AgGridReact> */}
            </div>
            {/* <div style={{ height: 400 }}>
                <DataGrid rows={rows} columns={columns} pageSize={5} density="compact" showToolbar checkboxSelection />
            </div> */}
        </React.Fragment>
    )
}

const LayoutGridCellEditor = React.forwardRef<unknown, ICellEditorParams>(({ data, colDef, api, stopEditing }, ref) => {
    var rowData: AgGridRowData = data;

    if (!api)
        throw new Error('API not available');

    const field = rowData.layoutGridRow.fields.find(f => f.columnName === colDef.field);
    if (!field)
        throw new Error(`Field ${colDef.field} not defined`);

    if (field instanceof ConfigurationProjectionLayoutGrid.StringField) {
        return <LayoutGridTestCellEditor api={api} stopEditing={stopEditing} ref={ref} field={field} />
    }
    else if (field instanceof ConfigurationProjectionLayoutGrid.NumericField) {
        return <LayoutGridNumericCellEditor api={api} stopEditing={stopEditing} ref={ref} field={field} />
    }
    else if (field instanceof ConfigurationProjectionLayoutGrid.BooleanField) {
        return <LayoutGridBooleanCellEditor api={api} stopEditing={stopEditing} ref={ref} field={field} />
    }
    else if (field instanceof ConfigurationProjectionLayoutGrid.StringEnumerableField) {
        return <LayoutGridStringEnumerableCellEditor api={api} stopEditing={stopEditing} ref={ref} field={field} />
    }
    else if (field instanceof ConfigurationProjectionLayoutGrid.NumericEnumerableField) {
        return <LayoutGridNumericEnumerableCellEditor api={api} stopEditing={stopEditing} ref={ref} field={field} />
    }
    else {
        return <LayoutGridUnknownCellEditor api={api} stopEditing={stopEditing} ref={ref} field={field} />
    }
});

interface LayoutGridTestCellEditorProps {
    api: GridApi;
    stopEditing: (suppressNavigateAfterEdit?: boolean | undefined) => void;
    field: ConfigurationProjectionLayoutGrid.StringField;
}
const LayoutGridTestCellEditor = React.forwardRef<unknown, LayoutGridTestCellEditorProps>(({ field }, ref) => {
    const [ value, setValue ] = React.useState<string>('');
    React.useEffect(() => {
        if (field.value) {
            setValue(field.value);
        }
    }, [ field ]);

    const error = !value;

    const inputRef = React.useRef<HTMLInputElement>(null);
    React.useImperativeHandle(ref, () => {
        return {
            getValue: () => {
                return value;
            },
            isCancelAfterEnd() {
                console.log('isCancelAfterEnd');
                return value === undefined;
            },
            afterGuiAttached: () => {
                inputRef.current?.focus();
                inputRef.current?.select();
            }
        }
    });

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value);
    }

    return <TextField inputRef={inputRef} variant="outlined" placeholder="Value" value={value ?? ''} onChange={onChange} fullWidth style={{ height: '100%' }} InputProps={{ style: { height: '100%' } }} error={error} />;
});

interface LayoutGridNumericCellEditorProps {
    api: GridApi;
    stopEditing: (suppressNavigateAfterEdit?: boolean | undefined) => void;
    field: ConfigurationProjectionLayoutGrid.NumericField;
}
const LayoutGridNumericCellEditor = React.forwardRef<unknown, LayoutGridNumericCellEditorProps>(({ field }, ref) => {
    const [ value, setValue ] = React.useState<string>('');
    React.useEffect(() => {
        if (field.value) {
            setValue(field.value.toString());
        }
    }, [ field ]);

    const error = (() => {
        if (!value || !isNumeric(value))
            return true;

        const numericValue = parseFloat(value);
        if (numericValue < field.min || numericValue > field.max)
            return true;

        return false;
    })();

    const inputRef = React.useRef<HTMLInputElement>(null);
    React.useImperativeHandle(ref, () => {
        return {
            getValue: () => {
                return value;
            },
            isCancelAfterEnd() {
                return !!error;
            },
            afterGuiAttached: () => {
                inputRef.current?.focus();
                inputRef.current?.select();
            }
        }
    });

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value);
    }

    return <TextField inputRef={inputRef} variant="outlined" placeholder="Value" value={value} onChange={onChange} fullWidth style={{ height: '100%' }} InputProps={{ style: { height: '100%' } }} error={error} />;
});

interface LayoutGridBooleanCellEditorProps {
    api: GridApi;
    stopEditing: (suppressNavigateAfterEdit?: boolean | undefined) => void;
    field: ConfigurationProjectionLayoutGrid.BooleanField;
}
const LayoutGridBooleanCellEditor = React.forwardRef<unknown, LayoutGridBooleanCellEditorProps>(({ stopEditing, field }, ref) => {
    const [ value, setValue ] = React.useState<string>('');
    React.useEffect(() => {
        if (field.value) {
            setValue(field.value.toString());
        }
    }, [ field ]);

    const [ ready, setReady ] = React.useState<boolean>();
    React.useEffect(() => {
        if (ready) {
            setReady(false);
            stopEditing();
        }
    }, [ ready ]);

    const [ open, setOpen ] = React.useState<boolean>(false);

    const error = !value;

    const inputRef = React.useRef<HTMLInputElement>(null);
    const selectRef = React.useRef<HTMLSelectElement>(null);
    React.useImperativeHandle(ref, () => {
        return {
            getValue: () => {
                return value;
            },
            isCancelAfterEnd() {
                // console.log('isCancelAfterEnd', value)
                // return value === undefined;
                return false;
            },
            afterGuiAttached: () => {
                inputRef.current?.focus();

                setOpen(true);
            }
        }
    });

    const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setValue(e.target.value);
        setReady(true);
    }
    const onOpen = () => {
        setOpen(true);
    }
    const onClose = () => {
        setOpen(false);
    }

    return (
        <FormControl fullWidth error={error} style={{ height: '100%' }}>
            <Select open={open} onClose={onClose} onOpen={onOpen} ref={selectRef} inputRef={inputRef} placeholder="Value" value={value} onChange={onChange} style={{ height: '100%' }}>
                <MenuItem value="<RESET>">{`<Reset>`}</MenuItem>
                <MenuItem value="true">Yes</MenuItem>
                <MenuItem value="false">No</MenuItem>
            </Select>
        </FormControl>
    )
});

interface LayoutGridStringEnumerableCellEditorProps {
    api: GridApi;
    stopEditing: (suppressNavigateAfterEdit?: boolean | undefined) => void;
    field: ConfigurationProjectionLayoutGrid.StringEnumerableField;
}
const LayoutGridStringEnumerableCellEditor = React.forwardRef<unknown, LayoutGridStringEnumerableCellEditorProps>(({ stopEditing, field }, ref) => {
    const [ value, setValue ] = React.useState<string>('');
    React.useEffect(() => {
        if (field.assignmentState !== ConfigurationCore.AssignmentStates.Unassigned) {
            setValue(field.value || 'nil');
        }
    }, [ field ]);

    const [ ready, setReady ] = React.useState<boolean>();
    React.useEffect(() => {
        if (ready) {
            setReady(false);
            stopEditing();
        }
    }, [ ready ]);

    const [ open, setOpen ] = React.useState<boolean>(false);

    const error = !value;

    const inputRef = React.useRef<HTMLInputElement>(null);
    const selectRef = React.useRef<HTMLSelectElement>(null);
    React.useImperativeHandle(ref, () => {
        return {
            getValue: () => {
                return value;
            },
            isCancelAfterEnd() {
                // console.log('isCancelAfterEnd', value)
                // return value === undefined;
                return false;
            },
            afterGuiAttached: () => {
                inputRef.current?.focus();

                if (field.allowCustomValue)
                    inputRef.current?.select();

                setOpen(true);
            }
        }
    });

    if (field.allowCustomValue) {
        const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            setValue(e.target.value);
            setReady(true);
        }

        return <TextField inputRef={inputRef} variant="outlined" placeholder="Value" value={value} onChange={onChange} fullWidth style={{ height: '100%' }} InputProps={{ style: { height: '100%' } }} error={error} />;
    }
    else {
        const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
            setValue(e.target.value);
            setReady(true);
        }
        const onOpen = () => {
            setOpen(true);
        }
        const onClose = () => {
            setOpen(false);
        }

        return (
            <FormControl fullWidth error={error} style={{ height: '100%' }}>
                <Select open={open} onClose={onClose} onOpen={onOpen} ref={selectRef} inputRef={inputRef} placeholder="Value" value={value} onChange={onChange} style={{ height: '100%' }}>
                    <MenuItem value="<RESET>">{`<Reset>`}</MenuItem>
                    {/* <MenuItem value="null">{`<Null>`}</MenuItem> */}
                    {field.answers.map(answer => <MenuItem value={(answer.isValueDefined ? answer.value?.toString() : undefined) || 'nil'}>{answer.displayName} [{ConfigurationCore.OptionStates[answer.assignmentState]}]</MenuItem>)}
                </Select>
            </FormControl>
        )
    }
});

interface LayoutGridNumericEnumerableCellEditorProps {
    api: GridApi;
    stopEditing: (suppressNavigateAfterEdit?: boolean | undefined) => void;
    field: ConfigurationProjectionLayoutGrid.NumericEnumerableField;
}
const LayoutGridNumericEnumerableCellEditor = React.forwardRef<unknown, LayoutGridNumericEnumerableCellEditorProps>(({ field, stopEditing }, ref) => {
    const [ value, setValue ] = React.useState<string>('');
    React.useEffect(() => {
        setValue(field.value?.toString() || 'nil');
    }, [ field ]);

    const [ ready, setReady ] = React.useState<boolean>();
    React.useEffect(() => {
        if (ready) {
            setReady(false);
            stopEditing();
        }
    }, [ ready ]);

    const [ open, setOpen ] = React.useState<boolean>(false);

    const error = !value;

    const inputRef = React.useRef<HTMLInputElement>(null);
    const selectRef = React.useRef<HTMLSelectElement>(null);
    React.useImperativeHandle(ref, () => {
        return {
            getValue: () => {
                return value;
            },
            isCancelAfterEnd() {
                return value === undefined;
            },
            afterGuiAttached: () => {
                inputRef.current?.focus();

                if (field.allowCustomValue)
                    inputRef.current?.select();

                setOpen(true);
            }
        }
    });

    if (field.allowCustomValue) {
        const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            setValue(e.target.value);
            setReady(true);
        }

        return <TextField inputRef={inputRef} variant="outlined" placeholder="Value" value={value} onChange={onChange} fullWidth style={{ height: '100%' }} InputProps={{ style: { height: '100%' } }} error={error} />;
    }
    else {
        const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
            setValue(e.target.value);
            setReady(true);
        }
        const onOpen = () => {
            setOpen(true);
        }
        const onClose = () => {
            setOpen(false);
        }

        return (
            <FormControl fullWidth error={error} style={{ height: '100%' }}>
                <Select open={open} onClose={onClose} onOpen={onOpen} ref={selectRef} inputRef={inputRef} placeholder="Value" value={value} onChange={onChange} style={{ height: '100%' }}>
                    <MenuItem value="<RESET>">{`<Reset>`}</MenuItem>
                    {/* <MenuItem value="null">{`<Null>`}</MenuItem> */}
                    {field.answers.map(answer => <MenuItem value={(answer.isValueDefined ? answer.value?.toString() : undefined) || 'nil'}>{answer.displayName} [{ConfigurationCore.OptionStates[answer.assignmentState]}]</MenuItem>)}
                </Select>
            </FormControl>
        )
    }
});


interface LayoutGridUnknownCellEditorProps {
    api: GridApi;
    stopEditing: (suppressNavigateAfterEdit?: boolean | undefined) => void;
    field: ConfigurationProjectionLayoutGrid.AField;
}
const LayoutGridUnknownCellEditor = React.forwardRef<unknown, LayoutGridUnknownCellEditorProps>(({ field }, ref) => {
    // const [ value, setValue ] = React.useState<string>();

    const inputRef = React.useRef<HTMLInputElement>(null);
    React.useImperativeHandle(ref, () => {
        return {
            afterGuiAttached: () => {
                inputRef.current?.focus();
                inputRef.current?.select();
            }
        }
    });

    // const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     setValue(e.target.value);
    // }

    return <TextField inputRef={inputRef} variant="outlined" placeholder="Unsupported" disabled fullWidth style={{ height: '100%' }} InputProps={{ style: { height: '100%' } }} error />;
});

function LayoutGridCellRenderer({ data, colDef }: ICellRendererParams) {
    var rowData: AgGridRowData = data;

    const field = rowData.layoutGridRow.fields.find(f => f.columnName === colDef.field);
    if (!field) {
        return <em>INVALID!!!</em>
    }
    else {
        const bg = field.validationMessages.length > 0 ? 'red' : undefined;

        return <em style={{ backgroundColor: bg }}>{field.getPropertyValue('value').toString()}</em>
    }
}

function resolveColDef(column: ConfigurationProjectionLayoutGrid.Column): ColDef {
    const colDef: ColDef = {
        field: column.name,
        headerName: column.displayName,
        cellRenderer: 'layoutGridCellRenderer',
        cellEditor: 'layoutGridCellEditor'
    };

    // switch (column.fieldType) {
    //     case ConfigurationProjectionLayoutGrid.FieldTypes.StringEnumerable:
    //     case ConfigurationProjectionLayoutGrid.FieldTypes.NumericEnumerable:
    //         colDef.cellEditor = 'agRichSelectCellEditor';
    //         break;
    // }

    return colDef;
}

function isNumeric(num: any){
    return !isNaN(num)
  }